const auth = {
    getToken: () => {
        return localStorage.getItem('token');
    },
}

export default auth;